/*
 * Copyright (c) Nexign, JSC, 2019.
 */
/**
 *
 * @author Evgenij Tyan
 * @author Yakov Gushchin
 * @version 1.0.0
 * @since 1.0.0
 */
import produce from 'immer';
import { Reducer } from 'redux';

import { UserInfoTypes } from '../actions/authCacheActions';
import {
    CACHE_USER_DATA_START,
    CACHE_USER_DATA_START_FAILURE,
    CACHE_USER_DATA_START_SUCCESSFUL,
    CHECK_USER_DATA_CACHE,
} from '../constants/authCacheConstants';

export interface IAuthCacheState {
    errorMessage?: string;
    isUserDataCached: boolean;
    caching: boolean;
}

export const initialCacheState: IAuthCacheState = {
    errorMessage: '',
    isUserDataCached: false,
    caching: false,
};

/**
 * @description userReducer required to work with user info
 * @param {IUserInfoState} state
 * @param {UserInfoTypes} action
 * @return {Produced<IUserInfoState, void>}
 */

const authCacheReducer: Reducer<IAuthCacheState> =
    (state: IAuthCacheState = initialCacheState, action: UserInfoTypes) =>
        produce(state, (draft) => {
            switch (action.type) {
                case CACHE_USER_DATA_START:
                    draft.caching = true;
                    break;
                case CACHE_USER_DATA_START_SUCCESSFUL:
                    draft.caching = false;
                    break;
                case CACHE_USER_DATA_START_FAILURE:
                    draft.errorMessage = action.payload;
                    draft.caching = false;
                    break;
                case CHECK_USER_DATA_CACHE:
                    draft.isUserDataCached = action.payload;
                    break;
                default:
                    break;
            }
        });

export default authCacheReducer;
